import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ChiaveConfig, EXACT_TIME_MODE } from '../../models/configurazioni/ChiaveConfig';

/**
 * Il servizio che recupera le configurazioni applicative
 */
@Injectable( { providedIn: 'root' })
export class ConfigService {
  private configurazioni: Array<any>;

  useExactTimeDocStud: boolean;
  useExactTimeStudOnly: boolean;
  useExitManagement: boolean;
  studentCanReportAbsence: boolean;
  isAfam: boolean;
  showStudentName: boolean;
  indicaErogazioneFruizione: boolean;
  enableOldRilCreation: boolean;
  indicaTipoAttivita: boolean;
  minTipoAttivitaS: string;
  minDocSearchChars: number;

  constructor(public httpClient: HttpClient) {
    console.log('Hello ConfigService Provider');
  }

  getConfigurazione(chiave: ChiaveConfig): any {

    if (this.configurazioni) {
      const conf = this.configurazioni.filter(c => chiave === c.chiave);
      if (conf && conf.length > 0) {
        return conf[0].valore;
      }
    }
    console.log('impossibile trovare la configurazione ' + chiave);
    return undefined;
  }
/*
  caricaConfigurazioni_old(): Observable<any> {
    if (this.configurazioni) {
      return of(this.configurazioni);
    } else {
      return this.http.get('configurazioni').pipe(
        map(this.parseResponse, this));
    }
  }*/
  /*  con l'httpClient la chiamata va modificata in questo modo .  */
  caricaConfigurazioni(): Observable<any> {
    if (this.configurazioni) {
      return of(this.configurazioni);
    } else {
      return this.httpClient.get<any>('configurazioni').pipe(
            map(this.parseConfigurazioni, this));
    }
  }

  initParams() {
    this.useExactTimeDocStud = this.getConfigurazione(ChiaveConfig.USE_EXACT_TIME) === EXACT_TIME_MODE.DOCSTUD;
    this.useExactTimeStudOnly = this.getConfigurazione(ChiaveConfig.USE_EXACT_TIME) === EXACT_TIME_MODE.STUDONLY;
    this.useExitManagement = this.getConfigurazione(ChiaveConfig.USE_EXIT_MANAGEMENT) === 'true';
    this.studentCanReportAbsence = this.getConfigurazione(ChiaveConfig.STUDENT_CAN_REPORT_ABSENCE) === 'true';
    this.isAfam = this.getConfigurazione(ChiaveConfig.E3_BASE_URL) !== 'nil';
    this.indicaErogazioneFruizione = this.getConfigurazione(ChiaveConfig.INDICA_EROGAZIONE_FRUIZIONE) === 'true';
    this.enableOldRilCreation = this.getConfigurazione(ChiaveConfig.DOC_CAN_CREATE_OLD_RIL) === 'true';
    this.indicaTipoAttivita = this.getConfigurazione(ChiaveConfig.INDICA_TIPO_ATTIVITA) === 'true';
    this.minTipoAttivitaS = this.getConfigurazione(ChiaveConfig.MIN_TIPO_ATTIVITA) === 'nil' ? '': this.getConfigurazione(ChiaveConfig.MIN_TIPO_ATTIVITA); 
    this.minDocSearchChars = this.getConfigurazione(ChiaveConfig.MIN_DOC_SEARCH_CHARS); 
    this.setShowStudentName();
    }
  /**
   * svuota le configurazioni eventualmente precaricate
   */
  cleanup() {
    this.configurazioni = undefined;
  }

  setShowStudentName() {
    this.showStudentName = true;
    const hiddenFields = this.getConfigurazione(ChiaveConfig.REPORTS_HIDDEN_FIELDS);
    const hfList = hiddenFields.split(',').map(item => item.trim());
    if (hfList.includes('nome_stud')) {
      this.showStudentName = false;
    }
  }

  /**
    * parsing della risposta e aggiunta di eventuali metodi di businness
    */

    //  private parseResponse(response: Response) {
  private parseConfigurazioni(confs: any) {
    this.configurazioni = confs;
    if (this.configurazioni) {
      // const c =  {id: 49, chiave: 48, valore: 'true'};
      // this.configurazioni.push(c);
      return this.configurazioni;
    }
  }

}
